'use client';
import { useCallback, useLayoutEffect, useRef } from 'react';
/**
 * Keeps callback identity stable for subscriptions while calling the latest committed implementation.
 * Calls are ignored while the implementation is undefined.
 */
// oxlint-disable-next-line typescript/no-explicit-any
export function useCallbackRef(impl) {
    const implRef = useRef(impl);
    useLayoutEffect(() => {
        implRef.current = impl;
    }, [impl]);
    return useCallback((...args) => implRef.current?.(...args), []);
}
//# sourceMappingURL=useCallbackRef.js.map